import styled from "styled-components";
import { mediaMinWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 6;
  width: 100vw;
  background-color: ${(props) => props.color === "white" && "#fff"};
  background-color: ${(props) => props.color === "purple" && "#402680"};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  transition: height 0s, opacity 0.2s ease-in-out;

  ${mediaMinWidth.tablet`
    display: none;
  `}
`;

export const Modal = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 220px;
  height: 200px;
  border-radius: 8px;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 135px;
  height: 95px;
`;

export const Spinner = styled.img`
  width: 40px;
  height: 40px;
  align-self: center;
`;
